/**
 * Upload-Tags ("Alben" wie Kindergarten, Hochzeit): Normalisierung und Sammeln.
 * Serverseitig identisch in Upload::normalizeMetaTags (meta.tags).
 */
export const TAG_MAX_LENGTH = 40
export const TAGS_MAX_COUNT = 20

export function normalizeTag(value: unknown): string {
  return String(value ?? '').replace(/\s+/g, ' ').trim().slice(0, TAG_MAX_LENGTH)
}

/** Kommagetrennte Eingabe oder Liste → eindeutige, getrimmte Tags (Groß-/Kleinschreibung egal). */
export function normalizeTags(input: unknown): string[] {
  const raw = Array.isArray(input) ? input : typeof input === 'string' ? input.split(/[,;\n]/) : []
  const out: string[] = []
  const seen = new Set<string>()
  for (const item of raw) {
    const tag = normalizeTag(item)
    if (!tag) continue
    const key = tag.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    out.push(tag)
    if (out.length >= TAGS_MAX_COUNT) break
  }
  return out
}

export function tagsEqual(a: unknown, b: unknown): boolean {
  const x = normalizeTags(a).map((t) => t.toLowerCase()).sort()
  const y = normalizeTags(b).map((t) => t.toLowerCase()).sort()
  return x.length === y.length && x.every((t, i) => t === y[i])
}

export function hasTag(tags: unknown, tag: string): boolean {
  const key = normalizeTag(tag).toLowerCase()
  return !!key && normalizeTags(tags).some((t) => t.toLowerCase() === key)
}

/** Alle Tags einer Bildliste mit Häufigkeit, alphabetisch. */
export function collectTags(items: Array<{ tags?: unknown } | null | undefined>): Array<{ tag: string; count: number }> {
  const map = new Map<string, { tag: string; count: number }>()
  for (const it of items) {
    for (const tag of normalizeTags(it?.tags)) {
      const key = tag.toLowerCase()
      const cur = map.get(key)
      if (cur) cur.count++
      else map.set(key, { tag, count: 1 })
    }
  }
  return [...map.values()].sort((a, b) => a.tag.localeCompare(b.tag, 'de'))
}
